import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import X46MK2ConfiguratorImageWithOverlays from './X46MK2ConfiguratorImageWithOverlays'
import ConfiguratorOption from './../ConfiguratorOption'
import RadioGroup from './../RadioGroup'
import Toggle from '../Toggle'
import { withTranslation, Trans } from 'react-i18next'
import { exteriorView10ImageOptions } from './views/ExteriorView10'

class X46MK2Deck extends Component {
  constructor (props) {
    super(props)
    this.handleDeckChange = this.handleDeckChange.bind(this)
    this.handleTeakOnSideDecksChange =
      this.handleTeakOnSideDecksChange.bind(this)
    this.handleTeakOnCoachroofChange =
      this.handleTeakOnCoachroofChange.bind(this)
  }

  handleDeckChange (newValue) {
    let configuration = this.props.configuration
    configuration.TeakDeck = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  handleTeakOnSideDecksChange (event) {
    let configuration = this.props.configuration
    configuration.TeakOnSideDecks = event.target.checked
      ? { value: 2, label: 'true' }
      : { value: 1, label: 'false' }

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  handleTeakOnCoachroofChange (event) {
    let configuration = this.props.configuration
    configuration.TeakOnCoachRoof = event.target.checked
      ? { value: 2, label: 'true' }
      : { value: 1, label: 'false' }

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  render () {
    let imageOptions = exteriorView10ImageOptions

    let image = (
      <X46MK2ConfiguratorImageWithOverlays
        boat='X46MK2'
        configuration={this.props.configuration}
        options={imageOptions}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Deck & cockpit' />
          </h1>
          <p>
            <Trans defaults='Standard on the X4<sup>6</sup> is genuine teak on cockpit floor and seats. Genuine teak is with black caulkings and optional is Flexiteek finish with grey stripes.' />
          </p>

          <RadioGroup
            label={this.props.t('Deck material:')}
            options={this.props.deckOptions}
            value={this.props.configuration.TeakDeck}
            onChange={this.handleDeckChange}
          />

          <p>
            <img
              style={{ border: '1px solid #c2c2c2', width: '50%' }}
              src={this.props.configuration.TeakDeck.preview}
              alt={this.props.configuration.TeakDeck.label}
            />
          </p>

          <h3>
            <Trans defaults='Deck options:' />
          </h3>

          <Toggle
            checked={this.props.configuration.TeakOnSideDecks.value === 2}
            onChange={this.handleTeakOnSideDecksChange}
          >
            <Trans
              defaults='{{wood}} on side decks'
              values={{
                wood:
                  this.props.configuration.TeakDeck.value === 1
                    ? 'Teak'
                    : 'Flexiteek'
              }}
            />
          </Toggle>
          <Toggle
            checked={this.props.configuration.TeakOnCoachRoof.value === 2}
            onChange={this.handleTeakOnCoachroofChange}
          >
            <Trans
              defaults='{{wood}} on coachroof'
              values={{
                wood:
                  this.props.configuration.TeakDeck.value === 1
                    ? 'Teak'
                    : 'Flexiteek'
              }}
            />
          </Toggle>
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46MK2Deck)



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2Deck.js